import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="bg-[#FBFBF9] min-h-screen pt-32 pb-24" data-testid="privacy-policy-page">
      <div className="max-w-[900px] mx-auto px-6 lg:px-12">
        <Link to="/" data-testid="back-home-link" className="inline-flex items-center gap-2 text-sm text-[#555] hover:text-[#111] mb-8 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Torna alla home
        </Link>
        <div className="overline">Informativa</div>
        <h1 className="font-serif-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#111]">Privacy Policy</h1>
        <p className="text-[#555] mt-4 text-sm">Ultimo aggiornamento: 10 giugno 2026</p>

        <div className="mt-12 prose-content text-[#111] leading-relaxed space-y-8">
          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">1. Titolare del trattamento</h2>
            <p>
              Il titolare del trattamento dei dati personali è <strong>Marano Consulting</strong>,
              con sede in Via Roma 544/A, 80017 Melito di Napoli (NA).<br />
              Email: <a href="mailto:info@consulenzamarano.com" className="text-[#1B3022] underline">info@consulenzamarano.com</a><br />
              Telefono: 081 1836 6932
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">2. Tipologie di dati raccolti</h2>
            <p>Attraverso questo sito raccogliamo i seguenti dati personali, forniti volontariamente dall'utente tramite il modulo di contatto:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Nome e cognome</li>
              <li>Indirizzo email</li>
              <li>Numero di telefono (facoltativo)</li>
              <li>Area di interesse</li>
              <li>Oggetto e contenuto del messaggio</li>
            </ul>
            <p className="mt-3">
              Vengono inoltre raccolti automaticamente dati di navigazione (indirizzo IP, tipo di browser,
              pagine visitate) solo per finalità tecniche di funzionamento del sito.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">3. Finalità del trattamento</h2>
            <p>I dati personali forniti vengono trattati esclusivamente per le seguenti finalità:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Rispondere alle richieste di informazioni inviate tramite il modulo di contatto</li>
              <li>Fornire i servizi professionali di consulenza richiesti</li>
              <li>Adempiere agli obblighi di legge, contabili e fiscali</li>
              <li>Garantire la sicurezza tecnica e il corretto funzionamento del sito</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">4. Base giuridica del trattamento</h2>
            <p>
              Il trattamento dei dati è basato sul <strong>consenso</strong> espresso dall'utente al momento
              dell'invio del modulo di contatto (art. 6 par. 1 lett. a GDPR) e sulla necessità di dare seguito
              a richieste precontrattuali (art. 6 par. 1 lett. b GDPR).
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">5. Modalità del trattamento</h2>
            <p>
              I dati sono trattati con strumenti elettronici e protocolli di sicurezza idonei a garantirne
              la riservatezza e l'integrità. Le email inviate dal modulo di contatto vengono recapitate
              tramite il servizio Resend (terza parte conforme al GDPR) e archiviate sui server cloud
              dell'infrastruttura di hosting.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">6. Periodo di conservazione</h2>
            <p>
              I dati raccolti tramite il modulo di contatto vengono conservati per il tempo necessario
              a rispondere alla richiesta e, in caso di instaurazione di un rapporto professionale,
              per il tempo previsto dagli obblighi di legge (in genere 10 anni per i documenti fiscali e contabili).
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">7. Comunicazione e diffusione</h2>
            <p>
              I dati non saranno diffusi e non saranno comunicati a terzi, salvo per:
            </p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Fornitori di servizi tecnici necessari (hosting, invio email) che agiscono come responsabili del trattamento</li>
              <li>Autorità pubbliche in caso di obblighi di legge</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">8. Diritti dell'interessato</h2>
            <p>In conformità al GDPR (Regolamento UE 2016/679), l'utente ha diritto a:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Accedere ai propri dati personali</li>
              <li>Richiederne la rettifica o la cancellazione</li>
              <li>Limitarne il trattamento o opporsi al loro utilizzo</li>
              <li>Ricevere i propri dati in formato strutturato (portabilità)</li>
              <li>Revocare in qualsiasi momento il consenso prestato</li>
              <li>Presentare reclamo al Garante per la Protezione dei Dati Personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-[#1B3022] underline">www.garanteprivacy.it</a>)</li>
            </ul>
            <p className="mt-3">
              Per esercitare i propri diritti è sufficiente inviare una richiesta a{" "}
              <a href="mailto:info@consulenzamarano.com" className="text-[#1B3022] underline">info@consulenzamarano.com</a>.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">9. Trasferimento extra-UE</h2>
            <p>
              I dati sono trattati prevalentemente all'interno dell'Unione Europea. Alcuni fornitori
              tecnici (es. servizi cloud) potrebbero trattare i dati al di fuori dell'UE in conformità
              alle clausole contrattuali standard approvate dalla Commissione Europea.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">10. Cookie</h2>
            <p>
              Per informazioni sull'utilizzo dei cookie sul sito, consulta la nostra{" "}
              <Link to="/cookie-policy" className="text-[#1B3022] underline">Cookie Policy</Link>.
            </p>
          </section>

          <section>
            <h2 className="font-serif-display text-2xl text-[#111] mb-3">11. Modifiche alla presente informativa</h2>
            <p>
              Marano Consulting si riserva il diritto di modificare la presente Privacy Policy in qualsiasi momento.
              La versione aggiornata sarà sempre disponibile su questa pagina, con indicazione della data di ultima revisione.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
